<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table id="table" *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th (click)="exportexcel()">First Name</th>
        <th>Last Name</th>
        <th>
          <input
            type="text"
            class="form-control"
            id="search-text"
            aria-describedby="search-text"
            [(ngModel)]="searchText"
            placeholder="Search"
            autofocus
          />
        </th>
        <!-- <th>Status</th> -->
        <th>Role</th>
        <th>
          <button
            class="add"
            mat-raised-button
            color="basic"
            (click)="addNew()"
          >
            Add New
          </button>
        </th>
      </tr>
      <tr class="td" *ngFor="let title of filterddata">
        <td>{{ title.First_Name }}</td>
        <td>{{ title.Last_Name }}</td>
        <!-- <td>{{title.Flag}}</td> -->
        <td>{{ title.Phone_No }}</td>
        <td>{{ title.designation }}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(title)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="isUserActive(title) ? Deactivate(title) : activate(title)"
          >
            {{ isUserActive(title) ? "Deactivate" : "Activate" }}
          </button>
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>

  <div *ngSwitchCase="'add'">
    <div [ngSwitch]="new">
      <form
        [formGroup]="stateForm"
        (ngSubmit)="onSubmit($event)"
        class="post"
        *ngSwitchCase="'form1'"
      >
        <div class="post">
          <div class="title">Create User</div>
          <div class="form">
            <span class="input">
              <mat-form-field>
                <mat-label>First Name</mat-label>
                <input formControlName="First_Name" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input formControlName="Last_Name" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>User Name</mat-label>
                <input formControlName="U_Name" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Address</mat-label>
                <input formControlName="Address" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Mobile No.</mat-label>
                <input
                  formControlName="Phone_No"
                  type="number"
                  matInput
                  placeholder=""
                />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input formControlName="Email_id" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Qualification</mat-label>
                <input
                  formControlName="qualification"
                  matInput
                  placeholder=""
                />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Password</mat-label>
                <input formControlName="password" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select formControlName="Flag" matNativeControl required>
                  <mat-option value="ACTIVE">ACTIVE</mat-option>
                  <mat-option value="INACTIVE">INACTIVE</mat-option>
                </mat-select>
              </mat-form-field>
            </span>
            <!-- <span class="input">
                <mat-form-field>
                    <mat-label>Designation</mat-label>
                    <mat-select formControlName="designation" matNativeControl required>
                      <mat-option *ngFor="let type of position" [value]="type.OptionValue">
                        {{type.OptionName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </span> -->
            <span class="input">
              <mat-form-field>
                <mat-label>Designation</mat-label>
                <input formControlName="designation" matInput placeholder="" />
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Can Give Discount</mat-label>
                <mat-select formControlName="CanAuthDiscount" matNativeControl>
                  <mat-option value="true">Yes</mat-option>
                  <mat-option value="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            </span>
            <span class="input">
              <mat-form-field>
                <mat-label>Position</mat-label>
                <mat-select
                  formControlName="Position_Id"
                  matNativeControl
                  required
                >
                  <mat-option
                    *ngFor="let type of position"
                    [value]="type.OptionValue"
                  >
                    {{ type.OptionName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
            <span class="input">
              For remote user's signature,
              <span style="color: blue; cursor: pointer" (click)="remoteUser()"
                >please click here</span
              >
              <div *ngIf="signatureUpload">
                <label>Upload Signature Image</label><br />
                <input
                  type="file"
                  accept="image/*"
                  (change)="onFileSelected($event)"
                /><br />
                <!-- <img
                  *ngIf="signatureImage"
                  [src]="signatureImage"
                  style="max-width: 200px"
                /> -->
              </div>
            </span>
            <div class="img">
              <img [src]="signatureImage" *ngIf="signatureImage" />
            </div>
          </div>
          <div class="errorMessage">
            <div *ngIf="Errors" class="error">
              <p>{{ Errors }}</p>
            </div>
          </div>
          <div class="errorMessage">
            <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
            </div>
          </div>
          <div class="but">
            <button
              type="button"
              class="button"
              mat-raised-button
              color="primary"
              (click)="addSign1()"
              style="width: 150px"
            >
              Sign
            </button>
            <button
              class="button"
              style="margin-left: 20px"
              type="submit"
              mat-raised-button
              color="primary"
            >
              {{ isLoading ? "Saving..." : "Save" }}
            </button>
          </div>
        </div>
      </form>
      <div *ngSwitchCase="'sign1'">
        <div class="sign">
          <ng-signature-pad
            doneButtonText="Add"
            format="base64"
            doneButtonClass="btn btn-primary"
            clearButtonClass="btn btn-primary"
            (done)="showImage1($event)"
          >
          </ng-signature-pad>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'edit'">
    <mat-tab-group>
      <mat-tab label="View User">
        <table>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Name :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.First_Name }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">User Name :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.U_Name }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Position :</div>
            </td>
            <td class="tr">
              <div class="name">{{ position_main }}</div>
            </td>
          </tr>
          <tr>
            <td class="tr">
              <div class="lable">Address :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.Address }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Mobile No. :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.Phone_No }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Status :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.Flag }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Designation :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.designation }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Password :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.password }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Qualification :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.qualification }}</div>
            </td>
          </tr>
          <tr class="tr">
            <td class="tr">
              <div class="lable">Can Give Discount :</div>
            </td>
            <td class="tr">
              <div class="name">{{ return?.CanAuthDiscount }}</div>
            </td>
          </tr>
        </table>
      </mat-tab>
      <mat-tab label="Edit User">
        <div [ngSwitch]="type">
          <form
            [formGroup]="stateForm"
            (ngSubmit)="onSubmit($event)"
            class="post"
            *ngSwitchCase="'form'"
          >
            <div class="post">
              <div class="title">Edit User</div>
              <div class="form">
                <span class="input">
                  <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input
                      formControlName="First_Name"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input
                      formControlName="Last_Name"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>User Name</mat-label>
                    <input formControlName="U_Name" matInput placeholder="" />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Address</mat-label>
                    <input formControlName="Address" matInput placeholder="" />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Mobile No.</mat-label>
                    <input
                      formControlName="Phone_No"
                      type="number"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input formControlName="Email_id" matInput placeholder="" />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Qualification</mat-label>
                    <input
                      formControlName="qualification"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input formControlName="password" matInput placeholder="" />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Status</mat-label>
                    <mat-select
                      formControlName="Flag"
                      matNativeControl
                      required
                    >
                      <mat-option value="ACTIVE">ACTIVE</mat-option>
                      <mat-option value="INACTIVE">INACTIVE</mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <!-- <span class="input">
                          <mat-form-field>
                              <mat-label>Designation</mat-label>
                              <mat-select formControlName="designation" matNativeControl required>
                                <mat-option *ngFor="let type of position" [value]="type.OptionValue">
                                  {{type.OptionName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                        </span> -->
                <span class="input">
                  <mat-form-field>
                    <mat-label>Designation</mat-label>
                    <input
                      formControlName="designation"
                      matInput
                      placeholder=""
                    />
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Can Give Discount</mat-label>
                    <mat-select
                      formControlName="CanAuthDiscount"
                      matNativeControl
                    >
                      <mat-option value="true">Yes</mat-option>
                      <mat-option value="false">No</mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  <mat-form-field>
                    <mat-label>Position</mat-label>
                    <mat-select
                      formControlName="Position_Id"
                      matNativeControl
                      required
                    >
                      <mat-option
                        *ngFor="let type of position"
                        [value]="type.OptionValue"
                      >
                        {{ type.OptionName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </span>
                <span class="input">
                  For remote user's signature,
                  <span
                    style="color: blue; cursor: pointer"
                    (click)="remoteUser()"
                    >please click here</span
                  >
                  <div *ngIf="signatureUpload">
                    <label>Upload Signature Image</label><br />
                    <input
                      type="file"
                      accept="image/*"
                      (change)="onFileSelected($event)"
                    /><br />
                    <!-- <img
                      *ngIf="signatureImage"
                      [src]="signatureImage"
                      style="max-width: 200px"
                    /> -->
                  </div>
                </span>
                <div class="img">
                  <img [src]="signatureImage" *ngIf="signatureImage" />
                </div>
              </div>
              <div class="errorMessage">
                <div *ngIf="Errors" class="error">
                  <p>{{ Errors }}</p>
                </div>
              </div>
              <div class="errorMessage">
                <div *ngIf="Success" class="Success">
                  <p>Saved Succesfully</p>
                </div>
              </div>
              <div class="but">
                <button
                  type="button"
                  class="button"
                  mat-raised-button
                  color="primary"
                  (click)="addSign()"
                  style="width: 150px"
                >
                  Sign
                </button>
                <button
                  type="submit"
                  class="button"
                  style="width: 150px; margin-left: 20px"
                  mat-raised-button
                  color="primary"
                >
                  {{ isLoading ? "Saving..." : "Save" }}
                </button>
                <!-- <button type="button" class="button" mat-raised-button color="primary" (click)="deactivate()" style="width: 200px; margin-left: 20px;"> Deactivate</button>
                    <button type="button" class="button" mat-raised-button color="primary" (click)="activate()" style="width: 170px; margin-left: 20px;"> Activate</button> -->
              </div>
            </div>
          </form>

          <div *ngSwitchCase="'sign'">
            <div class="sign">
              <ng-signature-pad
                doneButtonText="Add"
                format="base64"
                doneButtonClass="btn btn-primary"
                clearButtonClass="btn btn-primary"
                (done)="showImage($event)"
              >
              </ng-signature-pad>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
